module.exports = __webpack_public_path__ + "static/media/node-hosting-mobile.398e254d.avif";